import { render } from "./VSwiper.vue?vue&type=template&id=1a159d10"
import script from "./VSwiper.vue?vue&type=script&lang=js"
export * from "./VSwiper.vue?vue&type=script&lang=js"

import "./VSwiper.vue?vue&type=style&index=0&id=1a159d10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__